import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";
import { Flex } from "metabase/ui";

export const FilterHeaderRoot = styled(Flex)`
  border-bottom: 1px solid ${color("border")};
`;
